import { useLocation, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import Button from "@/components/button";
import { LeftArrow } from "@/components/icons";
import { useRole } from "@/utils/hooks/use-role";

interface BackButtonProps {
  onClick?: () => void;
}

export default function BackButton({ onClick }: BackButtonProps = {}) {
  const location = useLocation();
  const navigate = useNavigate();
  const role = useRole();
  const { t } = useTranslation("common");

  function handleSmartBack() {
    const hasAnySearch = Object.keys(location.search).length > 0;
    const maxSteps = 10;
    let steps = 0;

    function goBackUntilCleanUrl() {
      const hasParams = window.location.search.length > 0;
      if (!hasParams) {
        return;
      }
      if (steps >= maxSteps) {
        navigate({ to: "/app/$role/dashboard", params: { role }, search: {} });
        return;
      }
      steps += 1;
      window.history.back();
      setTimeout(goBackUntilCleanUrl, 10);
    }

    if (hasAnySearch) {
      goBackUntilCleanUrl();
      return;
    }

    // If already clean, fallback to dashboard
    navigate({ to: "/app/$role/dashboard", params: { role }, search: {} });
  }

  const handleClick = onClick ? onClick : handleSmartBack;

  return (
    <Button variant="outline" className="w-[120px]" onClick={handleClick}>
      <span className="flex items-center gap-[2px] w-full">
        <LeftArrow /> {t("actions.back")}
      </span>
    </Button>
  );
}
